import { url } from '../../axios/api_urls/event'
const api = require('../../axios/request')
import Vue from 'vue'


// store
const state = {
    // 文件或者图片最大的 size
    maxSize: {
        img: 10,
        file: 20
    }
}

// getters
const getters = {

}

// mutations
const mutations = {

}

// actions
const actions = {
    // 上传大小限制
    checkSize({state}, payload, _this){
        payload.type = payload.type === 'file' ? 'file' : 'img'
        return new Promise((resolve, reject) => {
            if (payload.size > state.maxSize[payload.type]*1024*1024){
                payload._this.$message.error(`${payload._this.$t('txt.file')} ${payload._this.$t('message.fileMaxSize')} ${state.maxSize[payload.type]}M`)
                reject()
            } else {
                resolve()
            }
        })
    },
    // 上传
    upload (context, payload) {
        return api._upload(url.upload, payload)
    },
    uploadWatermark (ontext, payload) {
      return api._upload(url.uploadWatermark, payload)
    },
    // event add
    activityAdd(content, payload) {
        return api._post(url.activityAdd, payload)
    },
    // event list
    activityList(content, payload) {
        return api._post(url.activityList, payload)
    },
    // event Detail
    activityDetail(content, payload) {
        return api._post(url.activityDetail, payload)
    },
    // event 编辑修改接口
    activityUpdate(content, payload) {
        return api._post(url.activityUpdate, payload)
    },
    // speaker List 的接口
    speakerList(content, payload) {
        return api._post(url.speakerList, payload)
    },
    // speaker time & address
    speakerTimeAndAddress(content, payload) {
        return api._post(url.speakerTimeAndAddress, payload)
    },
    // speaker time & address Detail
    speakerAddressDetail(content, payload) {
        return api._post(url.speakerAddressDetail, payload)
    },
    // speaker time & address Update
    speakerAddressAddAndUpdate(content, payload) {
        return api._post(url.speakerAddressAddAndUpdate, payload)
    },
    // speaker dialog Detail
    speakerDetail(content, payload) {
        return api._post(url.speakerDetail, payload)
    },
    // formulatio Category List
    formulationCategoryList(content, payload) {
        return api._post(url.formulationCategoryList, payload)
    },
    // formulatio Categorys Update
    formulationCategoryAddAndUpdate(content, payload) {
        return api._post(url.formulationCategoryAddAndUpdate, payload)
    },
    // formulation Category Detail
    formulationCategoryDetail(content, payload) {
        return api._post(url.formulationCategoryDetail, payload)
    },
    // formulation List
    formulationList(content, payload) {
        return api._post(url.formulationList, payload)
    },
    // 下拉选择
    selectBySegment(content, payload) {
        return api._post(url.selectBySegment, payload)
    },
    // formulation updata
    formulationAddAndUpdate(content, payload) {
        return api._post(url.formulationAddAndUpdate, payload)
    },
    // formulation detail
    formulationDetail(content, payload) {
        return api._post(url.formulationDetail, payload)
    },
    // product Category List
    productCategoryList(content, payload) {
        return api._post(url.productCategoryList, payload)
    },
    // product Category Update
    productCategoryUpdate(content, payload) {
        return api._post(url.productCategoryUpdate, payload)
    },
    // product Category Detail
    productCategoryDetail(content, payload) {
        return api._post(url.productCategoryDetail, payload)
    },
    // solution List
    solutionList(content, payload) {
        return api._post(url.solutionList, payload)
    },
    // solution Detail
    solutionDetail(content, payload) {
        return api._post(url.solutionDetail, payload)
    },
    // solution Add And Update
    solutionAddAndUpdate(content, payload) {
        return api._post(url.solutionAddAndUpdate, payload)
    },
    // product List
    productList(content, payload) {
        return api._post(url.productList, payload)
    },
    // product Add And Update
    productAddAndUpdate(content, payload) {
        return api._post(url.productAddAndUpdate, payload)
    },
    // product Detail
    productDetail(content, payload) {
        return api._post(url.productDetail, payload)
    },
    // event中的显示隐藏
    disableAndEnable(content, payload) {
        return api._post(url.disableAndEnable, payload)
    },
    // event的上线,下线
    eventStatusUpdate(content, payload) {
        return api._post(url.eventStatusUpdate, payload)
    },
    checkWeigth(content, payload) {
        return api._post(url.checkWeigth, payload)
    },
    // event的评论导出
    exportComment(content, payload) {
        return api._post(url.exportComment, payload)
    },
    // event的日志导出
    exportLog(content, payload) {
        return api._post(url.exportLog, payload)
    },
    // event的日志导出
    async deleteEventApi(content, payload) {
      try {
        const res = await api._post(url.deleteEvent, payload)
        return res.errorCode === 200
      } catch(error) {
        return false
      }
    },
    async searchTradeApi(content, payload) {
      try {
        const {data: res} = await api._post(url.searchTrade, payload)
        return res.records || []
      } catch(error) {
        return []
      }
    },
    async searchFormulationApi(content, payload) {
      try {
        const {data: res} = await api._post(url.searchFormulation, payload)
        return res || []
      } catch(error) {
        return []
      }
    },
    async getExportTotalApi(content, payload) {
      try {
        const {data: res} = await api._post(url.getExportTotal, payload)
        return res || 0
      } catch(error) {
        return 0
      }
    },
    async delSpeakerApi(content, payload) {
      try {
        const res = await api._post(url.delSpeaker, payload)
        return res && res.errorCode === 200
      } catch(error) {
        return false
      }
    },
    async delBasfProductSegmentApi(content, payload) {
      try {
        const res = await api._post(url.delBasfProductSegment, payload)
        return res && res.errorCode === 200
      } catch(error) {
        return false
      }
    },
    async delBasfProductApi(content, payload) {
      try {
        const res = await api._post(url.delBasfProduct, payload)
        return res && res.errorCode === 200
      } catch(error) {
        return false
      }
    },
    async delFormulationSegmentApi(content, payload) {
      try {
        const res = await api._post(url.delFormulationSegment, payload)
        return res && res.errorCode === 200
      } catch(error) {
        return false
      }
    },
    async delFormulationApi(content, payload) {
      try {
        const res = await api._post(url.delFormulation, payload)
        return res && res.errorCode === 200
      } catch(error) {
        return false
      }
    },
    getTrendListApi(content, payload) {
      return api._post(url.trendList, payload)
    },
    trendAddAndUpdate(content, payload) {
      return api._post(url.trendAddAndUpdate, payload)
    },
    trendDetailApi(content, payload) {
      return api._post(url.trendDetail, payload)
    },
    async delTrendApi(content, payload) {
      try {
        const res = await api._post(url.delTrend, payload)
        return res && res.errorCode === 200
      } catch(error) {
        return false
      }
    },
    getConceptListApi(content, payload) {
      return api._post(url.conceptList, payload)
    },
    conceptAddAndUpdate(content, payload) {
      return api._post(url.conceptAddAndUpdate, payload)
    },
    conceptDetailApi(content, payload) {
      return api._post(url.conceptDetail, payload)
    },
    async delConceptApi(content, payload) {
      try {
        const res = await api._post(url.delConcept, payload)
        return res && res.errorCode === 200
      } catch(error) {
        return false
      }
    },
    async searchConceptListApi(content, payload) {
      try {
        const { data: res } = await api._post(url.searchConceptList, payload)
        return res || []
      } catch(error) {
        return []
      }
    },
    async getTrendApi ({commit}, params) {
      try {
        const {data: res} = await api._post(url.searchTrend, params)
        return res
      } catch (e) {}
    },
  }


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/event.js